import {
  CreateFunctionInput,
  FunctionModelFragment,
  useUpdateFunctionMutation,
} from "@/graphql/types";
import { trim } from "@/graphql/utils/utils";
import { useToast } from "primevue/usetoast";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

export const useUpdateFunction = () => {
  const visible = ref(false);
  const toast = useToast();
  const { t } = useI18n();
  const id = ref<number>(0);
  const refUpdateFunction = ref<any>(null);
  const { loading, mutate, onError, onDone } = useUpdateFunctionMutation();
  const disableSubmit = computed(
    () => refUpdateFunction.value?.hasError.value || loading.value
  );

  onDone(({ errors }) => {
    if (errors) {
      toast.add({
        severity: "warn",
        summary: t("update.title"),
        detail: t("update.failed"),
        life: parseInt(process.env.VUE_APP_TOAST_LIFE),
      });
    }
    visible.value = false;
  });

  onError(() => {
    toast.add({
      severity: "warn",
      summary: t("update.title"),
      detail: t("update.failed"),
      life: parseInt(process.env.VUE_APP_TOAST_LIFE),
    });
  });

  const close = () => (visible.value = false);
  const openUpdate = (data: FunctionModelFragment) => {
    id.value = data.id;
    visible.value = true;
    setTimeout(() => {
      refUpdateFunction.value?.resetFields({
        name: data.name,
      });
    }, 100);
  };

  const onSubmit = (input: CreateFunctionInput) => {
    trim(input);
    void mutate({
      input: {
        ...input,
        id: id.value,
      },
    });
  };

  function submit() {
    refUpdateFunction.value?.validateFields().then(onSubmit);
  }

  return {
    disableSubmit,
    loading,
    visible,
    close,
    submit,
    openUpdate,
    refUpdateFunction,
    onSubmit,
  };
};
